import React from "react";
import { BrowserRouter } from "react-router-dom";
import { I18nProvider } from "@/coquille-bridge";
import { AuthProvider } from "@/context/AuthContext.jsx";
import { MarcelModeProvider } from "@/context/MarcelMode.jsx";
import { orignalI18nNamespaces } from "@/i18n/orignalI18n.js";
import { AppRoutes } from "@/routes.jsx";
import "@/styles/orignal.css";
import "@/styles/premium062.css";
import "@/styles/map063.css";
import "@/styles/tomorrow064.css";

export function App() {
  return (
    <I18nProvider defaultLang="fr" storageKey="orignal2026.lang" appNamespaces={orignalI18nNamespaces}>
      <AuthProvider>
        <MarcelModeProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </MarcelModeProvider>
      </AuthProvider>
    </I18nProvider>
  );
}
